import React, { useEffect } from 'react';
import { change as changeAction } from 'redux-form';
import { useSelector, useDispatch } from 'react-redux';
import { FieldForm } from '@app/src/common/FieldForm';
import { Select } from '@app/src/common/Select';
import { fetchTypePropertyAction, TypePropertyModel } from '@app/src/views/StepOne/form';
import { COLORS } from '@app/src/ui';
import { SelectItemModel } from '@app/src/common/Select/SelectModel';

interface Props {
  operation: number;
}

export const TypeProperty: React.FC<Props> = ({ operation }) => {
  const dispatch = useDispatch();
  const properties: SelectItemModel[] = useSelector(state => state.typeProperty.data);
  const isFetching: boolean = useSelector(state => state.typeProperty.isFetching);
  const print = useSelector(state => state.print.general);
  const currentProperty = useSelector(state => state.form.stepOne.values.property);
  
  useEffect(() => {
    dispatch(changeAction('stepOne', 'property', print.property));
    dispatch(changeAction('stepOne', 'propertyName', print.propertyName));
  }, []);
  
  useEffect(() => {
    dispatch(fetchTypePropertyAction(operation));
    if (operation !== print.operation) {
      dispatch(changeAction('stepOne', 'property', null));
      dispatch(changeAction('stepOne', 'propertyName', null));
    }
  }, [operation]);
  
  const handleChange = (property: TypePropertyModel) => {
    const { id, name } = property;
    dispatch(changeAction('stepOne', 'property', id));
    dispatch(changeAction('stepOne', 'propertyName', name));
  }

  return(
    <React.Fragment>
      <FieldForm label="Tipo de inmueble">
        <Select
          dataList={properties}
          handleChange={handleChange}
          placeholder="Seleccione un tipo de inmueble"
          modalTitle="Tipo de inmueble"
          optionColor={COLORS.GREEN}
          isLoading={isFetching}
          initialIndex={currentProperty}
        />
      </FieldForm>
    </React.Fragment>
  )
};
